"use client";

import { useTranslations } from "next-intl";
import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Popover,
} from "@/components/controls/base-controls";
import { PersonIcon } from "@/components/controls/icons";

type PassengerPopoverProps = {
    allowedValues: readonly number[];
    anchorEl: HTMLElement | null;
    open: boolean;
    selectedValue: number;
    onClose: (value: number) => void;
};

const PassengerPopover = (props: PassengerPopoverProps) => {
    const { allowedValues, anchorEl, open, selectedValue, onClose } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value: number) => {
        onClose(value);
    };

    const t = useTranslations();

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{ paper: { sx: { width: anchorEl?.clientWidth, mt: "8px" } } }}
        >
            <List sx={{ p: 0 }}>
                {allowedValues.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton onClick={() => handleListItemClick(item)}
                            sx={{ px: ".4em", backgroundColor: item === selectedValue ? "var(--mui-palette-selected-listitem-bg-color)" : undefined }}>
                            <ListItemAvatar sx={{ minWidth: "unset", mr: 1 }}>
                                <PersonIcon />
                            </ListItemAvatar>
                            <ListItemText primary={t("flightReq.passengers", { count: item })} sx={{mt: "-2px"}} slotProps={{ primary: { variant: "body2" } }} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Popover>
    );
};

export default PassengerPopover;
